const Landing = () => import('@/pages/account/Landing.vue');
const ChangePassword = () => import('@/components/form/ChangePassword.vue');
const ChangePasswordDone = () => import('@/components/form/ChangePasswordDone.vue');
const PartnerOnboarding = () => import('@/pages/account/PartnerOnboarding.vue');
const PartnerLogout = () => import('@/pages/account/PartnerLogout.vue');
const PartnerRedirect = () => import('@/pages/account/PartnerRedirect.vue');
const PartnerLoginError = () => import('@/pages/account/PartnerLoginError.vue');

const routes = [
  {
    path: '/login/',
    name: 'login',
    meta: {
      title: 'Login',
    },
    component: Landing,
  },
  {
    path: '/password_reset/',
    name: 'password_reset',
    meta: {
      title: 'Password Reset',
    },
    component: Landing,
  },
  {
    path: '/password_reset/done/',
    name: 'password_reset_done',
    meta: {
      title: 'Password Reset',
    },
    component: Landing,
  },
  {
    path: '/reset/:activationToken/:token/',
    name: 'reset_token',
    meta: {
      title: 'Password Reset',
    },
    component: Landing,
  },
  {
    path: '/password_change/',
    name: 'password_change',
    meta: {
      title: 'Password Change',
    },
    component: ChangePassword,
  },
  {
    path: '/password_change/done/',
    name: 'password_change_done',
    meta: {
      title: 'Password Change',
    },
    component: ChangePasswordDone,
  },
  {
    path: '/partner-onboarding/',
    name: 'partner-onboarding',
    meta: {
      title: 'Partner Onboarding',
    },
    component: PartnerOnboarding,
  },
  {
    path: '/partner-redirect/',
    name: 'partner-redirect',
    meta: {
      title: 'Partner Redirect',
    },
    component: PartnerRedirect,
  },
  {
    path: '/partner-logout/',
    name: 'partner-logout',
    meta: {
      title: 'Partner Logout',
    },
    component: PartnerLogout,
  },
  {
    path: '/partner-login-error/',
    name: 'partner-login-error',
    meta: {
      title: 'Partner Login Error',
    },
    component: PartnerLoginError,
  },
];

export default routes;
